"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../index");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _NotificationHandler = _interopRequireDefault(require("../../handlers/NotificationHandler"));

var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Notification = /*#__PURE__*/function (_Component) {
  _inherits(Notification, _Component);

  var _super = _createSuper(Notification);

  function Notification(props) {
    var _this;

    _classCallCheck(this, Notification);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "hideTimer", null);

    _defineProperty(_assertThisInitialized(_this), "alertDefinition", null);

    _this.show = _this.show.bind(_assertThisInitialized(_this));
    _this.hide = _this.hide.bind(_assertThisInitialized(_this));
    _this.setNewState = _this.setNewState.bind(_assertThisInitialized(_this));
    _this.setStateFromProps = _this.setStateFromProps.bind(_assertThisInitialized(_this));
    _this.isShowing = _this.isShowing.bind(_assertThisInitialized(_this));
    _this.handlePushable = _this.handlePushable.bind(_assertThisInitialized(_this));
    _this.alertDefinition = _this.setStateFromProps(props);
    _this.state = _this.setStateFromProps(props);
    return _this;
  }

  _createClass(Notification, [{
    key: "show",
    value: function show() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          display: true
        });

        if (!_this2.state.showCloseBtn) {
          clearTimeout(_this2.hideTimer);
          _this2.hideTimer = setTimeout(function () {
            _NotificationHandler["default"].hide();
          }, _this2.state.hideAfter);
        }
      }, this.state.showAfter);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.setState({
        display: false
      });

      if (this.state.closeCallback) {
        this.state.closeCallback();
      }
    }
  }, {
    key: "setNewState",
    value: function setNewState(state) {
      this.setState(this.setStateFromProps(state));
    }
  }, {
    key: "isShowing",
    value: function isShowing() {
      return this.state.display;
    }
  }, {
    key: "setStateFromProps",
    value: function setStateFromProps(props) {
      var nextProps = props || {};
      var definition = this.alertDefinition || {};
      var newState = {
        pushable: nextProps.pushable !== undefined ? nextProps.pushable : definition.pushable !== undefined ? definition.pushable : true,
        display: this.state ? this.state.display : false,
        colorTheme: nextProps.colorTheme || definition.colorTheme || 'soft-chill',
        className: nextProps.className || definition.className || '',
        text: nextProps.text || definition.text || null,
        buttons: nextProps.buttons || definition.buttons || null,
        style: nextProps.style || definition.style || {},
        hideAfter: nextProps.hideAfter || definition.hideAfter || 5000,
        showAfter: nextProps.showAfter || definition.showAfter || 0,
        transitionTime: nextProps.transitionTime || definition.transitionTime || 200,
        closeCallback: nextProps.closeCallback || definition.closeCallback || null,
        showCloseBtn: nextProps.showCloseBtn !== undefined ? nextProps.showCloseBtn : definition.showCloseBtn !== undefined ? definition.showCloseBtn : true
      };

      if (newState.showCloseBtn) {
        clearTimeout(this.hideTimer);
      }

      return newState;
    }
  }, {
    key: "handlePushable",
    value: function handlePushable() {
      var _this3 = this;

      setTimeout(function () {
        //Keeps has a reminder, 3.5rem should always be element height, unless design change
        //let heightElement = window.document.querySelector('#notification-component').clientHeight;
        if (_this3.state.display === true) {
          window.document.body.style.transition = _this3.state.transitionTime + 'ms all ease-in-out';
          window.document.body.style.marginTop = '3.5rem';
        } else {
          window.document.body.style.marginTop = '0px';
        }
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.pushable === true) {
        this.handlePushable();
      }

      var classes = (0, _classnames["default"])('notification-bar-component', this.state.classeName, this.state.colorTheme, {
        'show': this.state.display
      });
      var styles = {
        transitionDelay: '0ms',
        transitionDuration: "".concat(this.state.transitionTime, "ms"),
        transitionTimingFunction: 'ease',
        top: '-100px'
      };

      var right = /*#__PURE__*/_react["default"].createElement("div", null);

      if (this.state.showCloseBtn) {
        right = /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
          onClick: function onClick() {
            _NotificationHandler["default"].hide();
          },
          name: "glyph-remove"
        });
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "notification-component",
        className: classes,
        style: styles
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_index.FullBar, {
        left: /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
          name: "glyph-notifications",
          classNameContainer: "glyph"
        }),
        middle: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
          className: "notification-message"
        }, this.state.text), this.state.buttons !== null && /*#__PURE__*/_react["default"].createElement("div", {
          className: "buttonCol"
        }, this.state.buttons)),
        right: right
      })));
    }
  }]);

  return Notification;
}(_react.Component);

Notification.propTypes = {
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  buttons: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].object), _propTypes["default"].object]),
  showCloseBtn: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  colorTheme: _propTypes["default"].oneOf(['soft-chill', 'yellow']),
  hideAfter: _propTypes["default"].number,
  showAfter: _propTypes["default"].number,
  transitionTime: _propTypes["default"].number,
  closeCallback: _propTypes["default"].func,
  pushable: _propTypes["default"].bool,
  isExpress: _propTypes["default"].bool,
  isPriority: _propTypes["default"].bool
};
Notification.defaultProps = {};
var _default = Notification;
exports["default"] = _default;